import { QueryType } from '../../../utils/apollo/graphqlSchema';

export const DEFAULT_NEW_FOLDER_NAME = 'Untitled Folder';
export const FOLDER_NAME_MAX_LENGTH = 30;

export const dashboardSupportedQueryTypes = [
  QueryType.Expression,
  QueryType.Funnel,
  QueryType.Path,
  QueryType.Retention,
  QueryType.DataTable,
  QueryType.Significance,
];

export const DASHBOARD_MAX_COLUMNS_PER_ROW = 3;

/**
 * Dashboard row is divided into 12 columns and each cell can occupy (span
 * across) any number of them. The value 12 is chosen because it can be divided
 * into 2, 3, 6 and is consistent with other grid systems (like Bootstrap).
 * For example one cell can span across 3 of them while the one next to it must
 * span over 9 of them. The total number of columns must always be 12
 *
 * The value is unit-less - the actual (pixel) width of the colum is determined
 * by the user's viewport (how much space there is to render the dashboard).
 */
export const DASHBOARD_COLUMNS_PER_ROW = 12;

export const DASHBOARD_COMMENT_OVERLAY_Z_INDEX = 1;
export const DASHBOARD_REPORT_COMMENT_OVERLAY_Z_INDEX =
  DASHBOARD_COMMENT_OVERLAY_Z_INDEX + 1;
